import { differenceInCalendarDays, differenceInCalendarMonths } from 'date-fns';

/**
 * Calculate the base price for a booking.
 */
export const calcPrice = (space, pricingType, startDate, endDate) => {
  if (!space || !startDate) return 0;
  const opt = space.pricingOptions.find((p) => p.type === pricingType);
  if (!opt) return 0;
  if (pricingType === 'hourly' && endDate) {
    // Pro-rata pricing: 30-min increments charged at half the hourly rate.
    // Round to nearest 30 min to absorb any sub-minute drift, then divide by 60.
    const minutes = Math.round((endDate - startDate) / 60000 / 30) * 30;
    return (minutes / 60) * opt.price;
  }
  if (pricingType === 'daily' && endDate) {
    return differenceInCalendarDays(endDate, startDate) * opt.price;
  }
  if (pricingType === 'monthly' && endDate) {
    return differenceInCalendarMonths(endDate, startDate) * opt.price;
  }
  return opt.price;
};
